/**
 * Simple browser-based blob download helper; quickly downloads strings or blobs to a file
 *
 * @param {string | Blob} data - data to download
 * @param {string} filename - name to assign to the download file
 * @param {string} MIMEType - MIME type for the file
 * - For a list of MIME types, see https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
 *
 * @returns {Boolean} whether the download was successfully queued
 */
export function Download(data = '', filename = 'untitled.txt', MIMEType = 'txt/csv') {
  // Make sure document exists
  if (!self.document) {
    console.error('The download widget can only be used in the browser');
    return false;
  }

  let blob;
  // If data is already a blob, use it
  if (data instanceof Blob) blob = data;
  // If it is not, make it a blob
  else blob = new Blob([data], { type: MIMEType });

  // Create the download link
  let link = self.document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;

  // Click the link, and then remove it from the DOM
  link.click();
  link.remove();
  URL.revokeObjectURL(link.href);

  // Return true; the file was created
  return true;
}
